module.exports = __webpack_public_path__ + "static/media/close.1c2074d9.svg";